export function redirectWithParams(toUrl: string, params = new URLSearchParams(window.location.search)) {
  const url = new URL(toUrl, window.location.origin);
  // carry over all existing params
  url.search = params.toString();
  window.location.href = url.toString();
}
